import { render, staticRenderFns } from "./PCBScreeningTable.vue?vue&type=template&id=c7cb6c8e&scoped=true&"
import script from "./PCBScreeningTable.vue?vue&type=script&lang=js&"
export * from "./PCBScreeningTable.vue?vue&type=script&lang=js&"
import style0 from "./PCBScreeningTable.vue?vue&type=style&index=0&id=c7cb6c8e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cb6c8e",
  null
  
)

export default component.exports